export default "__VITE_ASSET__BHszEGlL__"